import React from 'react';
import './style.css';

const Error = props => <div className="Error">{props.children}</div>

export default Error
